import popupPrintingService from './popupPrintingService';
import qzTrayService from './qzTrayService';

/**
 * Unified Printing Service
 * 
 * Uses popup-based printing when running in iframe (GHL)
 * Falls back to direct QZ Tray for standalone mode
 */
class UnifiedPrintingService {
  constructor() {
    this.platform = 'web';
    
    // Detect if running in iframe
    this.isInIframe = window.self !== window.top;
    
    // Use popup service in iframe, direct QZ Tray otherwise
    if (this.isInIframe) {
      console.log('[UnifiedPrinting] Running in iframe - using popup printing');
      this.activeService = popupPrintingService;
    } else {
      console.log('[UnifiedPrinting] Standalone mode - using direct QZ Tray');
      this.activeService = qzTrayService;
    }
    
    console.log('[UnifiedPrinting] Platform: web, Service:', this.activeService.getEnvironmentInfo().service);
  }

  isAvailable() {
    return this.activeService.isAvailable();
  }

  async initialize() {
    return await this.activeService.initialize();
  }

  async listPrinters() {
    return await this.activeService.listPrinters();
  }

  async printReceipt(html, options = {}) {
    console.log('[UnifiedPrinting] printReceipt called with options:', JSON.stringify(options));
    return await this.activeService.printReceipt(html, options);
  }

  async printHTMLReceipt(html, printerName = null) {
    if (this.activeService.printHTMLReceipt) {
      return await this.activeService.printHTMLReceipt(html, printerName);
    }
    return await this.activeService.printReceipt(html, { printerName });
  }

  async openCashDrawer(printer) {
    return await this.activeService.openCashDrawer(printer);
  }

  async testPrint(printerName) {
    if (this.activeService.testPrint) {
      return await this.activeService.testPrint(printerName);
    }
    // Fallback test print
    const testHTML = `
      <html>
        <head>
          <style>
            body { font-family: monospace; text-align: center; margin: 0; padding: 10px; }
            h1 { font-size: 24px; margin: 10px 0; }
          </style>
        </head>
        <body>
          <h1>TEST PRINT</h1>
          <p>Castle POS</p>
          <p>${new Date().toLocaleString()}</p>
        </body>
      </html>
    `;
    return await this.printReceipt(testHTML, { printerName });
  }

  getEnvironmentInfo() {
    return {
      ...this.activeService.getEnvironmentInfo(),
      platform: this.platform,
      isNative: false,
      isInIframe: this.isInIframe
    };
  }
}

export default new UnifiedPrintingService();
